import service from '@/utils/server';

const modName='/bd/abnormalPurchOrder/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const purchOrderPageInfo = data => {
  return service({
    url: modName + 'initSubmit',
    method: 'post',
    data
  });
};

export const add = data => {
  return service({
    url: modName + 'submit',
    method: 'post',
    data
  });
};

export const unloadConfigExport = data => {
  let config = {
    responseType: "blob"
  };
  return service( {
    ...config,
    url: modName + 'unloadConfigExport',
    method: 'post',
    data
  });
};

export const getPurchOrder = data => {
  return service({
    url: modName + 'detail',
    method: 'post',
    data
  });
};

export const purchOrderSubmit = data => {
  return service({
    url: modName + 'submit',
    method: 'post',
    data
  });
};







// WEBPACK FOOTER //
// ./src/page/bd/order/abnormalPurchOrder/api/index.js